const posts = [
  {
    category: 'Inversión',
    title: '¿Por qué Baños del Inca es la mejor apuesta inmobiliaria del norte del Perú?',
    excerpt: 'La combinación de turismo termal, naturaleza y crecimiento sostenido hace de esta zona una de las más atractivas para inversores inmobiliarios de la región.',
    img: '/assets/blog/banos-inca.jpg',
    featured: true,
  },
  {
    category: 'Market Trends',
    title: 'Alta plusvalía 2025: zonas naturales como destino de inversión',
    excerpt: 'Tendencia global de inversores buscando propiedades en entornos naturales.',
    img: '/assets/blog/plusvalia.jpg',
    featured: false,
  },
  {
    category: 'Renovación & Lifestyle',
    title: '5 razones para invertir en un resort de lujo en preventa',
    excerpt: 'Descubre las ventajas de comprar en preventa y maximizar tu retorno de inversión.',
    img: '/assets/blog/invertir-preventa.jpg',
    featured: false,
  },
  {
    category: 'Inversión',
    title: 'Cómo generar ingresos pasivos con tu propiedad en Airbnb',
    excerpt: 'Estrategias reales para convertir tu casa de campo en una fuente de ingresos consistente.',
    img: '/assets/blog/airbnb.jpg',
    featured: false,
  },
];

export default function Blog() {
  const [featured, ...rest] = posts;

  return (
    <section id="blog" className="px-8 md:px-16 py-20 md:py-12 xl:py-20">
      {/* Header */}
      <div className="flex items-start justify-between mb-10 md:mb-7 xl:mb-10">
        <div>
          <p className="text-xs tracking-[.28em] text-gray-400 uppercase font-medium mb-3 md:mb-2 xl:mb-3">Recursos</p>
          <h2 className="text-3xl md:text-2xl xl:text-4xl font-bold text-black leading-tight">
            Últimas noticias<br/>
            <span className="font-light italic">&amp; recursos</span>
          </h2>
        </div>
        <button className="mt-2 flex-shrink-0 flex items-center gap-2 text-sm font-medium text-gray-600
          border border-gray-200 rounded-full px-4 py-2 md:px-3 md:py-1.5 md:text-xs xl:px-4 xl:py-2 xl:text-sm
          hover:border-gray-900 hover:text-black transition-all duration-200">
          Ver todos
          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 17L17 7M17 7H7M17 7v10"/>
          </svg>
        </button>
      </div>

      {/* Grid */}
      <div className="grid md:grid-cols-2 gap-4 md:gap-3 xl:gap-4">
        {/* Featured post */}
        <div className="group rounded-3xl overflow-hidden bg-gray-50 hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
          <div className="h-56 md:h-44 xl:h-56 overflow-hidden">
            <img src={featured.img} alt={featured.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
          </div>
          <div className="p-6 md:p-4 xl:p-6">
            <span className="text-[10px] tracking-[.22em] uppercase font-semibold text-gray-400">{featured.category}</span>
            <h3 className="font-bold text-black text-lg md:text-base xl:text-lg leading-snug mt-2 mb-3 md:mt-1.5 md:mb-2 xl:mt-2 xl:mb-3">{featured.title}</h3>
            <p className="text-gray-500 text-sm md:text-xs xl:text-sm font-light leading-relaxed mb-4 md:mb-3 xl:mb-4 line-clamp-2">{featured.excerpt}</p>
            <button className="flex items-center gap-1.5 text-sm md:text-xs xl:text-sm font-medium text-black hover:gap-2.5 transition-all duration-200">
              Leer más
              <svg className="w-3.5 h-3.5 md:w-3 md:h-3 xl:w-3.5 xl:h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3"/>
              </svg>
            </button>
          </div>
        </div>

        {/* Small posts */}
        <div className="flex flex-col gap-3 md:gap-2 xl:gap-3">
          {rest.map((post) => (
            <div key={post.title}
              className="group flex gap-4 md:gap-3 xl:gap-4 items-center bg-gray-50 rounded-2xl p-4 md:p-3 xl:p-4 hover:shadow-md transition-all duration-300 hover:-translate-y-0.5">
              <div className="w-20 h-20 md:w-16 md:h-16 xl:w-20 xl:h-20 rounded-xl md:rounded-lg xl:rounded-xl overflow-hidden flex-shrink-0">
                <img src={post.img} alt={post.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300" />
              </div>
              <div className="flex-1 min-w-0">
                <span className="text-[10px] tracking-[.2em] uppercase font-semibold text-gray-400">{post.category}</span>
                <h4 className="font-semibold text-black text-sm md:text-xs xl:text-sm leading-snug mt-0.5 mb-1 line-clamp-2">{post.title}</h4>
                <button className="flex items-center gap-1 text-xs md:text-[11px] xl:text-xs font-medium text-gray-500 hover:text-black hover:gap-2 transition-all duration-200">
                  Leer más
                  <svg className="w-3 h-3 md:w-2.5 md:h-2.5 xl:w-3 xl:h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3"/>
                  </svg>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
